<template>
  <div class="d-flex align-items-center mb-2" v-if="positionLeft || positionLeft == null">
    <div class="symbol  symbol-35px symbol-circle ">
      <img
          src="@/assets/images/Pre_01.png"
          alt=""
      />
    </div><!--end::Avatar-->
    <!--begin::Details-->
    <div class="ms-3">
      <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{user == null ? 'Admin' : user.name }}</a>
    </div>
    <!--end::Details-->
  </div>
    <!--end::Info-->
</template>

<script>
export default {
  name: 'AdminCardSimple',
  props: {
    user: {
      type: Object,
      required: false,
    },
    positionLeft: {
      type: Object,
      required: false,
    },
    isAdmin: {
      type: Object,
      required: false,
    },
  },
};
</script>
